package com.milta.core.localization.translations.en

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Refresh",
    expandedStopsTitle = "Stops",
    stopStatusWaitingLabel = "Waiting",
    stopStatusFailedLabel = "Not delivered",
)
